<template>
<div class="card">
    <div class="card-header">RDC Submission</div>
    <div class="card-body">
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>

        <b-form @submit.stop.prevent="onSubmit">
            <b-row>
                <b-col>
                    <LifecycleCheckList lifecycleStatus="18" :requestId="request.id"
                        v-on:checklist-update="updateChecklistStatus($event)" ref="checklist"/>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12" lg="4">
                    <BaseTextInput v-model="request.icsBranch"
                                    :v="$v.request.icsBranch"
                                    label="ICS Branch"
                                    tip=""
                                    slug="icsBranch"/>
                </b-col>
                <b-col cols="12" lg="4">
                    <BaseTextInput v-model="request.icsSection"
                                    :v="$v.request.icsSection"
                                    label="ICS Section"
                                    tip=""
                                    slug="icsSection"/>
                </b-col>
                <b-col cols="12" lg="4">
                    <BaseTextInput v-model="request.responseRoleName"
                                    :v="$v.request.responseRoleName"
                                    label="Response Role Name"
                                    tip=""
                                    slug="responseRoleName"/>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12" lg="4">
                    <BaseTextInput v-model="request.currentResponseRole"
                                    :v="$v.request.currentResponseRole"
                                    label="Current COVID-19 response role for selected staff"
                                    tip=""
                                    slug="currentResponseRole"/>
                </b-col>
                <b-col cols="12" lg="4">
                     <BaseClassificationSelector v-model="request.proposedClassification"
                            :v="$v.request.proposedClassification"
                            slug="classification"
                            label="Proposed Classification"
                            sr="Search for Proposed Classification"/>
                </b-col>
                <b-col cols="12" lg="4">
                    <BaseTextInput v-model="request.positionNumber"
                                    :v="$v.request.positionNumber"
                                    label="Position Number"
                                    tip=""
                                    slug="positionNumber"/>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <BaseParagraphInput v-model="comments"
                        :v="$v.comments" 
                        slug="rdcComments"
                        label="Internal Comments"/>
                </b-col>
            </b-row>
            
            <div>
                <b-button type="submit" variant="primary">Complete RDC Submission</b-button>
                <b-button type="button" variant="outline-primary" @click="save">Save</b-button>


                <b-button v-b-modal.modal-rdc-document variant="outline-primary">View RDC Transfer Data</b-button>
            </div>
        </b-form>
    </div>

    <b-modal id="modal-rdc-document" title="RDC Transfer Request" size="lg">
        <b-row>
            <b-col lg="12">
                <b-table-simple id="rdcTable" hover small caption-top responsive>
                        <b-thead>
                            <b-tr>
                                <b-th>Question</b-th>
                                <b-th>Response</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr>
                                <b-td>1. Requestor Name:</b-td>
                                <b-td>{{this.request.submitter.name}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>2. Primary Phone Number:</b-td>
                                <b-td>???</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>3. Secondary Phone Number:</b-td>
                                <b-td></b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>4. Primary Email address:</b-td>
                                <b-td>{{this.request.submitter.email}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>5. Secondary Email address:</b-td>
                                <b-td></b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>6. Agency:</b-td>
                                <b-td>MDH</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>7. Job Classification:</b-td>
                                <b-td>{{this.request.proposedClassification}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>8. COOP Priority:</b-td>
                                <b-td>{{this.request.coopLevel}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>9. Shift Coverage:</b-td>
                                <b-td>{{this.request.workScheduleValue.description}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>10. Job City Location:</b-td>
                                <b-td>{{this.request.workLocation}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>11. Job Location/Site Name:</b-td>
                                <b-td>{{this.request.workLocation}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>12. List site specific requirements:</b-td>
                                <b-td>???</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>13. Drivers license required:</b-td>
                                <b-td>{{this.request.dlRequired}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>13. Drivers license required:</b-td>
                                <b-td>{{this.request.dlRequired}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>15. List skills required:</b-td>
                                <b-td>{{this.request.skillSet}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>16. Licenses/Certifications required:</b-td>
                                <b-td>{{this.request.licCredsRequired}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>17. Telework option:</b-td>
                                <b-td>{{this.request.teleworkAvailable}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>18. Travel required:</b-td>
                                <b-td>{{this.request.workTravelValue.description}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>19. Date position needs to be filled:</b-td>
                                <b-td>{{this.request.anticipatedStartDate}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>20. PCN:</b-td>
                                <b-td>{{this.request.positionNumber}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>21. Funding String:</b-td>
                                <b-td>{{this.request.positionNumber}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>22. Comments:</b-td>
                                <b-td>{{this.request.comments}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td>23. Funding / Budget (y/n):</b-td>
                                <b-td>{{this.request.cfoCertifiedFunding}}</b-td>
                            </b-tr>
                            
                        </b-tbody>
                    </b-table-simple>
            </b-col>
        </b-row>
    </b-modal>
</div>

</template>

<script>
import axios from "axios"
import { required, email, minLength, maxLength, numeric } from 'vuelidate/lib/validators'
import LifecycleCheckList from '@/components/lifecycles/LifecycleCheckList'

export default {
    components: {
        LifecycleCheckList,
    },
    props: {
        request: Object
    },
    data() {
        return { 
            checklistComplete: true,
            comments: '',
            saveOnly: false,
        }
    },
     validations: {
         comments: { required: false, maxLength: maxLength(4000) },
         checklistComplete: { checked: value => value === true },
         request: { 
             icsBranch: { required: false, maxLength: maxLength(75) },
             icsSection: { required: false, maxLength: maxLength(75) },
             responseRoleName: { required: false, maxLength: maxLength(75) },
             currentResponseRole: { required: false, maxLength: maxLength(75) },
             proposedClassification: { required, maxLength: maxLength(75) },
             positionNumber: { required, maxLength: maxLength(8)},
         }
     },
    methods: {
        updateChecklistStatus(b) {
            this.checklistComplete = true
        },

        save() {
            this.saveOnly = true
            this.onSubmit()
            this.saveOnly = false
        },

        onSubmit() {
            if (!this.saveOnly) {
                this.$refs.checklist.emitCheckListStatus()
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$nextTick(() => {
                        document.getElementById('form-container').scrollIntoView()
                    })
                    return
                }
            }

            let payload = {
                requestId: this.request.id,
                comments: this.comments,
                icsBranch: this.request.icsBranch,
                icsSection: this.request.icsSection,
                responseRoleName: this.request.responseRoleName,
                currentResponseRole: this.request.currentResponseRole,
                proposedClassification: this.request.proposedClassification,
                positionNumber: this.request.positionNumber,
                advanceNextLifecycle: !this.saveOnly
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/rdcSubmission`, payload)
                .then(response => {                       
                this.showRootToast("RDC Submission Submitted", "updated.", "success")
                this.$emit('status-changed') 
                })                  
        },

        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })

        },
    }   
}
</script>